var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0 pb-offset"},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('print-setting',{attrs:{"model":"saleorder"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }